import React from 'react';
import { Link } from 'react-router-dom';

const Events: React.FC = () => {
  return (
    <section className="section bg-white">
      <div className="container-base">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Image */}
          <div className="img-frame aspect-[4/3] shadow-elevated">
            <img
              src="/board.png"
              alt="Donut Event Wall"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Text Content */}
          <div>
            <h2 className="section-title text-left">Donuts for Every Occasion</h2>
            <p className="text-sm sm:text-base lg:text-lg text-gray-700 leading-relaxed mb-6 sm:mb-8">
              Make your next event unforgettable with Alljoy Donut Co. Whether it's a wedding, birthday, office
              celebration, or pop-up market — our handcrafted donuts bring a whole lot of joy and a whole lot of
              flavor to your gathering.
            </p>

            {/* Event types */}
            <div className="flex flex-wrap gap-2 mb-6 sm:mb-8">
              {['Weddings', 'Birthdays', 'Corporate Events', 'Markets'].map((event) => (
                <span key={event} className="badge-orange">
                  {event}
                </span>
              ))}
            </div>

            <Link to="/contact" className="btn-teal">
              Book Your Event
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Events;
